// extracted by mini-css-extract-plugin
module.exports = {"wrap":"animation-text_wrap__-Y-MT","collapse":"animation-text_collapse__1ODHs"};